/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './concept-data-type.reducer';

export const ConceptDataTypeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const conceptDataTypeEntity = useAppSelector(state => state.conceptDataType.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="conceptDataTypeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.conceptDataType.detail.title">ConceptDataType</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.conceptDataType.id">Id</Translate>
            </span>
          </dt>
          <dd>{conceptDataTypeEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.conceptDataType.description">Description</Translate>
            </span>
          </dt>
          <dd>{conceptDataTypeEntity.description}</dd>
          <dt>
            <span id="hl7Abbreviation">
              <Translate contentKey="tinyMedicRestApp.conceptDataType.hl7Abbreviation">Hl 7 Abbreviation</Translate>
            </span>
          </dt>
          <dd>{conceptDataTypeEntity.hl7Abbreviation}</dd>
          <dt>
            <span id="uuid">
              <Translate contentKey="tinyMedicRestApp.conceptDataType.uuid">Uuid</Translate>
            </span>
          </dt>
          <dd>{conceptDataTypeEntity.uuid}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.conceptDataType.name">Name</Translate>
            </span>
          </dt>
          <dd>{conceptDataTypeEntity.name}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.conceptDataType.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{conceptDataTypeEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.conceptDataType.active">Active</Translate>
            </span>
          </dt>
          <dd>{conceptDataTypeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="created">
              <Translate contentKey="tinyMedicRestApp.conceptDataType.created">Created</Translate>
            </span>
          </dt>
          <dd>
            {conceptDataTypeEntity.created ? (
              <TextFormat value={conceptDataTypeEntity.created} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.conceptDataType.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{conceptDataTypeEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.conceptDataType.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{conceptDataTypeEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.conceptDataType.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{conceptDataTypeEntity.lastupdated}</dd>
        </dl>
        <Button tag={Link} to="/concept-data-type" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/concept-data-type/${conceptDataTypeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ConceptDataTypeDetail;
